<template>
  <div class="person-content">
    <p class="p"><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: 'PersonContent'
}
</script>

<style lang="scss" scoped>
.person-content {
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.44;
  text-align: left;
  color: $c-darktext;
}
.p {
  &:before, &:after {
    font-weight: $fw-bold;
    font-size: 40px;
    line-height: 0;
    color: $c-red;
    position: relative;
    top: 13px;
  }
  &:before {
    content: '“';
    padding-right: 0.1em;
  }
  &:after {
    content: '”';
    padding-left: 0.1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/person/PersonContent.vue